import { render, staticRenderFns } from "./storeGoodsAdd.vue?vue&type=template&id=f98b65ba&"
import script from "./storeGoodsAdd.vue?vue&type=script&lang=js&"
export * from "./storeGoodsAdd.vue?vue&type=script&lang=js&"
import style0 from "./storeGoodsAdd.vue?vue&type=style&index=0&id=f98b65ba&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports